import { render, staticRenderFns } from "./EmptyCartIconSvg.vue?vue&type=template&id=29e2ef9e&"
import script from "./EmptyCartIconSvg.vue?vue&type=script&lang=js&"
export * from "./EmptyCartIconSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports